const Generating = ({ text }) => {
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white px-6 py-4 rounded shadow text-sm font-medium">
        {text}
      </div>
    </div>
  );
};

export default Generating;
